import { prop } from 'datx';
import { Resource } from 'datx-jsonapi-react';

export class ProfilePlaylist extends Resource {
  public static type = 'profile_playlists';

  @prop
  public name: string;
}
